export default __webpack_public_path__ + "media/music/2c7831f92769d42b7af042d0875d8bc1.mp3";